import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConditionFieldDate } from './components/date/conditionFieldDate';
import { ConditionFieldDuration } from './components/duration/conditionFieldDuration';
import { ConditionFieldAgents, ConditionFieldChannel, ConditionFieldContacts, ConditionFieldDirection, ConditionFieldId, ConditionFieldQueue, ConditionFieldStatus, ConditionFieldTags, } from './components/select/conditionFieldSelect';
export const ConditionField = (props) => {
    const Component = useMemo(() => {
        switch (props.condition.field) {
            case 'numeric_id':
                return ConditionFieldId;
            case 'status':
                return ConditionFieldStatus;
            case 'initial_direction':
                return ConditionFieldDirection;
            case 'initial_channel':
                return ConditionFieldChannel;
            case 'queue_id':
                return ConditionFieldQueue;
            case 'agent_id':
                return ConditionFieldAgents;
            case 'requested_by':
                return ConditionFieldContacts;
            case 'tags':
                return ConditionFieldTags;
            case 'duration':
                return ConditionFieldDuration;
            default:
                return ConditionFieldDate;
        }
    }, [props.condition.field]);
    return _jsx(Component, Object.assign({}, props));
};
